
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import React from "react";

interface CTASectionWrapperProps {
  children?: React.ReactNode;
  backgroundImage?: string;
  backgroundColor?: string;
  className?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  reversed?: boolean;
}

const CTASectionWrapper = ({
  children,
  backgroundImage,
  backgroundColor = "bg-black",
  className,
  leftContent,
  rightContent,
  reversed = false,
}: CTASectionWrapperProps) => {
  if (leftContent && rightContent) {
    return (
      <section className={cn("relative overflow-hidden", backgroundColor, className)}>
        {backgroundImage && (
          <div className="absolute inset-0 bg-gradient-to-br from-anzir-muted/40 via-black to-anzir-muted/20 z-0"></div>
        )}
        {backgroundImage && (
          <div 
            className={cn("absolute inset-0 bg-cover bg-center opacity-10 z-0")}
            style={{ backgroundImage: `url('${backgroundImage}')` }}
          ></div>
        )}
        <div className="container mx-auto px-6 relative z-10">
          <div className={`flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center`}>
            <div className="flex-1">{leftContent}</div>
            <div className="flex-1">{rightContent}</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={cn("relative overflow-hidden", backgroundColor, className)}>
      {backgroundImage && (
        <div className="absolute inset-0 bg-gradient-to-br from-anzir-muted/40 via-black to-anzir-muted/20 z-0"></div>
      )}
      {backgroundImage && (
        <div 
          className={cn("absolute inset-0 bg-cover bg-center opacity-10 z-0")}
          style={{ backgroundImage: `url('${backgroundImage}')` }}
        ></div>
      )}
      <div className="relative z-10">
        {children}
      </div>
    </section>
  );
};

export default CTASectionWrapper;
